// source: v2/types/customer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var v2_types_authentication_method_pb = require('../../v2/types/authentication_method_pb.js');
goog.object.extend(proto, v2_types_authentication_method_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.Customer', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.DashboardName', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ServiceType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.Customer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.Customer.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.Customer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.Customer.displayName = 'proto.loopup.ctgateway.v2.Customer';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.Customer.repeatedFields_ = [8,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.Customer.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.Customer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Customer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    logoUrl: (f = msg.getLogoUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    createdAtTime: (f = msg.getCreatedAtTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAtTime: (f = msg.getUpdatedAtTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    tenancyId: (f = msg.getTenancyId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    abillityId: (f = msg.getAbillityId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    authenticationMethodsList: jspb.Message.toObjectList(msg.getAuthenticationMethodsList(),
    v2_types_authentication_method_pb.AuthenticationMethod.toObject, includeInstance),
    operatorConnectEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    directRoutingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    sipTrunksEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    servicesList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.Customer}
 */
proto.loopup.ctgateway.v2.Customer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.Customer;
  return proto.loopup.ctgateway.v2.Customer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.Customer}
 */
proto.loopup.ctgateway.v2.Customer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLogoUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAtTime(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAtTime(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTenancyId(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAbillityId(value);
      break;
    case 8:
      var value = new v2_types_authentication_method_pb.AuthenticationMethod;
      reader.readMessage(value,v2_types_authentication_method_pb.AuthenticationMethod.deserializeBinaryFromReader);
      msg.addAuthenticationMethods(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOperatorConnectEnabled(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDirectRoutingEnabled(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSipTrunksEnabled(value);
      break;
    case 12:
      var values = /** @type {!Array<!proto.loopup.ctgateway.v2.ServiceType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addServices(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.Customer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.Customer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.Customer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLogoUrl();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedAtTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAtTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTenancyId();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAbillityId();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAuthenticationMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      v2_types_authentication_method_pb.AuthenticationMethod.serializeBinaryToWriter
    );
  }
  f = message.getOperatorConnectEnabled();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDirectRoutingEnabled();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSipTrunksEnabled();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getServicesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue logo_url = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getLogoUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
*/
proto.loopup.ctgateway.v2.Customer.prototype.setLogoUrl = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.clearLogoUrl = function() {
  return this.setLogoUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Customer.prototype.hasLogoUrl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp created_at_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getCreatedAtTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
*/
proto.loopup.ctgateway.v2.Customer.prototype.setCreatedAtTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.clearCreatedAtTime = function() {
  return this.setCreatedAtTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Customer.prototype.hasCreatedAtTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getUpdatedAtTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
*/
proto.loopup.ctgateway.v2.Customer.prototype.setUpdatedAtTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.clearUpdatedAtTime = function() {
  return this.setUpdatedAtTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Customer.prototype.hasUpdatedAtTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue tenancy_id = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getTenancyId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
*/
proto.loopup.ctgateway.v2.Customer.prototype.setTenancyId = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.clearTenancyId = function() {
  return this.setTenancyId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Customer.prototype.hasTenancyId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue abillity_id = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getAbillityId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
*/
proto.loopup.ctgateway.v2.Customer.prototype.setAbillityId = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.clearAbillityId = function() {
  return this.setAbillityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Customer.prototype.hasAbillityId = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated AuthenticationMethod authentication_methods = 8;
 * @return {!Array<!proto.loopup.ctgateway.v2.AuthenticationMethod>}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getAuthenticationMethodsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.AuthenticationMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_authentication_method_pb.AuthenticationMethod, 8));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.AuthenticationMethod>} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
*/
proto.loopup.ctgateway.v2.Customer.prototype.setAuthenticationMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.AuthenticationMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.AuthenticationMethod}
 */
proto.loopup.ctgateway.v2.Customer.prototype.addAuthenticationMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.loopup.ctgateway.v2.AuthenticationMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.clearAuthenticationMethodsList = function() {
  return this.setAuthenticationMethodsList([]);
};


/**
 * optional bool operator_connect_enabled = 9;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getOperatorConnectEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.setOperatorConnectEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool direct_routing_enabled = 10;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getDirectRoutingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.setDirectRoutingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool sip_trunks_enabled = 11;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getSipTrunksEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.setSipTrunksEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * repeated ServiceType services = 12;
 * @return {!Array<!proto.loopup.ctgateway.v2.ServiceType>}
 */
proto.loopup.ctgateway.v2.Customer.prototype.getServicesList = function() {
  return /** @type {!Array<!proto.loopup.ctgateway.v2.ServiceType>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.ServiceType>} value
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.setServicesList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {!proto.loopup.ctgateway.v2.ServiceType} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.addServices = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.Customer} returns this
 */
proto.loopup.ctgateway.v2.Customer.prototype.clearServicesList = function() {
  return this.setServicesList([]);
};


/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.DashboardName = {
  DASHBOARD_NAME_INVALID: 0,
  DASHBOARD_NAME_ADVANCE_PAYMENT: 1,
  DASHBOARD_NAME_USAGE_SUMMARY: 2,
  DASHBOARD_NAME_INVOICE_REPORT: 3
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.ServiceType = {
  SERVICE_TYPE_INVALID: 0,
  SERVICE_TYPE_DIRECT_ROUTING: 1,
  SERVICE_TYPE_OPERATOR_CONNECT: 2,
  SERVICE_TYPE_SIP_TRUNKS: 3
};

goog.object.extend(exports, proto.loopup.ctgateway.v2);
